import axios from "../httpClient";

export const retrieveSecrets = async (applicantId, fields) => {
    const result = await axios.post(`/secrets/retrieve`, {
        applicantId,
        fields
    });
    return result.data;
};
